import { render, staticRenderFns } from "./MyCampaignCard.vue?vue&type=template&id=61465738&scoped=true"
import script from "./MyCampaignCard.vue?vue&type=script&lang=ts"
export * from "./MyCampaignCard.vue?vue&type=script&lang=ts"
import style0 from "./MyCampaignCard.vue?vue&type=style&index=0&id=61465738&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61465738",
  null
  
)

export default component.exports